import { confirmationRdvEspaceClientMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [confirmationRdvEspaceClientMock];

export const tunnelConfirmationEspaceClientMock: SlugPage = {
  ...pageBase({
    title: 'Tunnel RDV - Confirmation espace client',
    type: 'tunnel',
    language: 'fr-FR',
    headerId: '',
    footerId: '',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
